import SuperTokens from "supertokens-auth-react";
import Passwordless from "supertokens-auth-react/recipe/passwordless";
import ThirdParty from "supertokens-auth-react/recipe/thirdparty";
import Session from "supertokens-auth-react/recipe/session";
import {VITE_API_DOMAIN, VITE_APP_NAME, VITE_WEBSITE_DOMAIN} from "@/config";

export function initSuperTokens() {
  SuperTokens.init({
    appInfo: {
      appName: VITE_APP_NAME,
      apiDomain: VITE_API_DOMAIN,
      websiteDomain: VITE_WEBSITE_DOMAIN,
      apiBasePath: "/auth",
      websiteBasePath: "/auth",
    },
    recipeList: [
      ThirdParty.init({
        signInAndUpFeature: {
          providers: [
            ThirdParty.Google.init(),
            // ThirdParty.Apple.init(),  // Uncomment if using Apple
            // ThirdParty.Microsoft.init(),  // Uncomment if using Microsoft
          ],
        },
      }),
      Passwordless.init({
        contactMethod: "EMAIL",
      }),
      Session.init({
        tokenTransferMethod: "header",
      }),
    ],
  });
}
